import { t } from '@ankr.com/common';

import { ZKVERIFY_VFLOW_PARACHAIN_TESTNET_PATH } from 'modules/chains/constants';

import { root } from '../../../const';

export const renderZkVerifyTitle = (url: string, isLoggedIn: boolean) => {
  const pathArr = new URL(url).pathname
    .split('/')
    .filter(pathItem => !!pathItem);

  const pathArrLength = pathArr.length;

  const path = pathArr
    .slice(0, isLoggedIn ? pathArrLength - 1 : pathArrLength)
    .join('/');

  if (path === ZKVERIFY_VFLOW_PARACHAIN_TESTNET_PATH) {
    return t(`${root}.endpoints.vFlow-title`);
  }

  return t(`${root}.endpoints.volta-title`);
};
